export default __webpack_public_path__ + "assets/img/ict-lineStraight.9be30c0c7379424cec489c35e93b000f.svg";